// extracted by mini-css-extract-plugin
module.exports = {"container-4Column":"Container4Column_container-4Column__lWBhG","container-4Column__col":"Container4Column_container-4Column__col__RXIjR"};